import { ComponentType, Suspense, lazy } from 'react';

const TolgeeProviderLazy = lazy(() => import('@shared/lib/tolgee/TolgeeProvider'));

const withTolgeeProvider = <T extends { locale: string }>(Component: ComponentType<T>) => {
  const TolgeeWrapper = (props: T) => (
    <Suspense fallback={null}>
      <TolgeeProviderLazy locale={props.locale}>
        <Component {...props} />
      </TolgeeProviderLazy>
    </Suspense>
  );
  return TolgeeWrapper;
};

export default withTolgeeProvider;
